// extracted by mini-css-extract-plugin
export default {"root":"NavigationIcon_root__fTqQp"};